import { useCallback } from 'react'
import { useFormikContext } from 'formik'
import { CreateAgreementFormPacketModel } from '@user/components/Agreements/AgreementFormPacketDialog/typings'
import { DropResult } from '@user/utils/Draggable'

export function useHandlers() {
  const { setValues } = useFormikContext<CreateAgreementFormPacketModel>()

  const onDragEnd = useCallback(
    (result: DropResult) => {
      if (result.id === 'templates') {
        setValues((v) => {
          const templates = [...v.templates]

          const dragged = templates.splice(result.sourceIndex, 1).pop()
          if (!dragged) return v

          templates.splice(result.destinationIndex, 0, dragged)

          return { ...v, templates }
        })
      }
    },
    [setValues],
  )

  const onAddAgreementTemplate = useCallback(() => {
    setValues((v) => {
      const templates = [...v.templates]

      templates.push({
        templateId: -1 - templates.length,
        templateFormName: undefined,
      })

      return { ...v, templates }
    })
  }, [setValues])

  return {
    onDragEnd,
    onAddAgreementTemplate,
  }
}
